export class Breadcrumb {

  constructor(
    public label: string,
    public link: string,
    public params?: any,
    public type?: string
  ) { }

}



// WEBPACK FOOTER //
// /dist/src/app/ui/breadcrumbs/breadcrumb.model.ts